// const baseUrl = 'https://gdsc-rc.dscvit.com'
// const baseUrl = 'https://recruitment-dev.herokuapp.com'
const baseUrl = '/api'
export function url (suffix) {
  return baseUrl + suffix
}
